import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { MergeOrganizationParameters } from '../../components/admin/organization/advancedEditing/MergeOrganizationsForm';
import { ProgramAction, ProgramActionType } from '../actions/ProgramActions';
import { Program } from '../types';

export const getAllAdminPrograms =
    () => async (dispatch: Dispatch<ProgramAction>) => {
        const response = await SuSyApi.get(`/program/admin`);
        dispatch({
            type: ProgramActionType.GET_ALL_ADMIN_PROGRAMS,
            payload: response.data,
        });
    };
export const getAllPrograms =
    () => async (dispatch: Dispatch<ProgramAction>) => {
        const response = await SuSyApi.get(`/program`);
        dispatch({
            type: ProgramActionType.GET_ALL_PROGRAMS,
            payload: response.data,
        });
    };

export const getProgram =
    (program: Program) => async (dispatch: Dispatch<ProgramAction>) => {
        const response = await SuSyApi.get(`/program/${program._id}`);
        dispatch({
            type: ProgramActionType.GET_PROGRAM,
            payload: response.data,
        });
    };

export const createProgram =
    (program: Program) => async (dispatch: Dispatch<ProgramAction>) => {
        const response = await SuSyApi.post(`/program`, program);
        dispatch({
            type: ProgramActionType.CREATE_PROGRAM,
            payload: response.data,
        });
    };

export const updateProgram =
    (program: Program) => async (dispatch: Dispatch<ProgramAction>) => {
        const response = await SuSyApi.put(`/program/${program._id}`, program);
        dispatch({
            type: ProgramActionType.UPDATE_PROGRAM,
            payload: response.data,
        });
    };

export const deletePrograms =
    (ids: Array<string>, transferToId: string) =>
    async (dispatch: Dispatch<ProgramAction>) => {
        const response = await SuSyApi.delete(`/program`, {
            data: {
                ids,
                transferToId,
            },
        });
        dispatch({
            type: ProgramActionType.DELETE_PROGRAMS,
            payload: response.data,
        });
    };

export const mergePrograms =
    (parameters: MergeOrganizationParameters) =>
    async (dispatch: Dispatch<ProgramAction>) => {
        const response = await SuSyApi.post(`/program/merge`, parameters);
        dispatch({
            type: ProgramActionType.MERGE_PROGRAMS,
            payload: response.data,
        });
    };
